import React, {Component} from 'react'
import ProfileEditForm from './ProfileEditForm'
import {Row, Tabs, Tab} from 'react-bootstrap'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import {Form} from 'react-form'
import showToastr from '../../../../utils/showToastr'
import ErrorHandler from '../../../../utils/ErrorHandler'
import validateProfile from '../../../../utils/validateProfile'

class ProfileEditScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user,
      message: {status: '', context: ''},
      isLoading: false
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const {user, isLoading} = this.state
    return (
      <Row className="Box">
        {user && <Tabs defaultActiveKey={3} id="profile-edit-tab">
          <Tab eventKey={3} title="ویرایش پروفایل">
            <Form
              ref="form"
              values={user}
              disable={isLoading}
              isLoading={isLoading}
              validate={validateProfile}
              onSubmit={(values) => {
                this.setState({isLoading: true})
                Actions.userUpdate(values).then((res) => {
                  this.setState({isLoading: false})
                  showToastr('success', 'ویرایش پروفایل', res.messages[0])
                  browserHistory.push('/user/profile')
                }).catch((err) => {
                  let eh = new ErrorHandler(err)
                  this.setState({message: eh.message, isLoading: false})
                  eh.setFormErrors(this.refs.form)
                  eh.showToastrIn('ویرایش پروفایل')
                })
              }}>
              {ProfileEditForm}
            </Form>
          </Tab>
        </Tabs>}
      </Row>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser
  }
}

export default connect(mapStateToProps)(ProfileEditScreen)



// WEBPACK FOOTER //
// ./src/components/User/Profile/ProfileEdit/ProfileEditScreen.js